import type { Mutation, Query } from 'react-query';
import { EXCLUDE_ERROS, isUploadFileUrl } from 'services/api.errors';
import { CustomError } from 'types/errors';
import { protectApiError, protectAxiosError } from 'utils/typeGuards';
import { addDot } from 'utils';
import { Messages } from 'constants/messages';
import { showErrorToast, showInfoToast } from 'components/Toast';

export function handleCommonError(
  error: unknown,
  query: Query<unknown, unknown, unknown>,
): void;
export function handleCommonError(
  error: unknown,
  variables: unknown,
  context: unknown,
  mutation: Mutation<unknown, unknown, unknown, unknown>,
): void;
export function handleCommonError(
  arg1: unknown,
  arg2: unknown,
  arg3?: unknown,
  arg4?: Mutation<unknown, unknown, unknown, unknown>,
): void {
  /** All of Api error */
  if (protectApiError(arg1)) {
    if (
      arg1.response?.data &&
      Object.values<string>(EXCLUDE_ERROS).includes(arg1.response?.data.code)
    ) {
      return;
    }

    const title = arg1.response?.data.title;
    const message = arg1.response?.data.message;
    let text;

    if (title && message) {
      text = `${addDot(title)} ${addDot(message)}`;
    } else if (title || message) {
      text = (title || message) as string;
      if (text.indexOf('.') + 1 || text.indexOf(',') + 1) {
        text = addDot(text);
      }
    }

    const toastText = Boolean(text?.trim()) ? text : Messages.commonErrorMessage;
    showErrorToast(toastText as string);
    return;
  }

  if (protectAxiosError(arg1)) {
    switch (arg1.response?.status) {
      case 401:
        return;
      case 500:
      case 501:
        showErrorToast(Messages.commonErrorMessage);
        return;
      case 504:
        if (isUploadFileUrl(arg1.config?.url ?? '')) {
          showInfoToast(Messages.operationIsBeingProcessed);
        } else {
          showErrorToast(Messages.commonErrorMessage);
        }
        return;
      default:
        showErrorToast(Messages.commonErrorMessage);
    }
  }

  if (arg1 instanceof CustomError) {
    showErrorToast(arg1.notificationText);
  }
}
